import '@shared/styles/globals.css';
import { mountApp } from '@shared/app/AppRoot';
import { financeConfig } from '@/app.config';
import { financeRoutes } from '@/routes';
import { pruneInvoicePreviews } from '@/modules/invoicing/detail/preview-store';

// Invoice previews past their 30 minutes go at start-up, opened again or not.
pruneInvoicePreviews();
mountApp(financeConfig, financeRoutes);
